import React from 'react';
import RadioGroup from '@nib-components/radio-group';
import BaseFormField from '../base-form-field';
const YesNoRadio = _ref => {
  let {
    inline = true,
    options = {
      yes: 'Yes',
      no: 'No'
    },
    ...otherProps
  } = _ref;
  return React.createElement(BaseFormField, {
    ...otherProps
  }, React.createElement(RadioGroup, {
    inline: inline,
    options: options
  }));
};
YesNoRadio.defaultProps = {
  inline: true,
  options: {
    yes: 'Yes',
    no: 'No'
  }
};
export default YesNoRadio;